import syncDocumentTypes from "../../constants/syncDocumentTypes";

const isIgnorableSyncType = documentOrFolder => {
  const isDocumentType = documentOrFolder === syncDocumentTypes.TEXT;
  const isFolderType =
    documentOrFolder === syncDocumentTypes.FOLDER ||
    documentOrFolder === syncDocumentTypes.DRAFT_FOLDER ||
    documentOrFolder === syncDocumentTypes.RESEARCH_FOLDER;
  return !isDocumentType && !isFolderType;
};

export default isIgnorableSyncType;
